<template>
	<div class="myCont">
		<div class="main">
			<div class="infosearch">
				<el-input v-model="keyName" placeholder="输入调理师姓名/手机号查询" @keyup.native='specialCharacter' style="width: 284px;margin-right: 10px"></el-input>
				<el-button class="searchBtn" @click="search(1)" v-loading.fullscreen.lock="fullscreenLoading"></el-button>
				<el-button class="addMems" @click="addMemes">添加兼职调理师</el-button>  
			</div>
			<el-table
				v-if="tableData.length > 0"
				:data="tableData"
				height='601'
				ref="multipleTable"
                :cell-class-name="tableRowClassName"
				class="myMemTable"
				style="width: 100%" :header-cell-style="{background:'#EFF1F5'}">
				<el-table-column align="center" type="index" label="序号" width="80"></el-table-column>
				<el-table-column align="center" prop="memberId" label="userID" width="200"></el-table-column>
				<el-table-column align="center" prop="name" label="姓名">
          <template slot-scope="scope">
						{{scope.row.name | filterRow}}
					</template>
        </el-table-column>
				<el-table-column align="center" prop="phone" label="手机号"></el-table-column>
				<el-table-column align="center" prop="source" label="主攻产业">
					<template slot-scope="scope">
						{{scope.row.source | filterSource | filterRow}}
					</template>
				</el-table-column>
				<el-table-column align="center" prop="createTimeOff" label="状态">
					<template slot-scope="scope">
						{{scope.row.createTimeOff | formatDateLine | filterRow}}
					</template>
				</el-table-column>
				<el-table-column align="center" label="认证码">
					<template slot-scope="scope">
						{{scope.row.pointsOff - scope.row.consumedPointsOff}}
					</template>
				</el-table-column>
				<el-table-column align="center" prop="accountOff" label="挂靠时间"></el-table-column>
				<el-table-column align="center" prop="consumedOff" label="关系生效时间"></el-table-column>
				<el-table-column align="center" label="操作" class-name="operation">
					<template slot-scope="scope">
						<el-button size="mini" type="danger" @click="editMem(scope.row.memberId)">修改</el-button>
						<el-button size="mini" type="primary" @click="viewMem(scope.row.memberId)">查看</el-button>
					</template>
				</el-table-column>
			</el-table>
			<template v-else>
				<div class="emptys">查不到该调理师信息！请核对查询条件是否有误~</div>
			</template>

			<el-pagination  v-show="total"
                @size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="currentPage"
				:page-sizes="[10, 20, 30, 40]"
				:page-size="pageSize"
				background
				layout="total, sizes, prev, pager, next, jumper"
				:total="total" style="margin-top: 20px;text-align:right">
			</el-pagination>
		</div>
	</div>
</template>
<script type="text/javascript">
import { searchMem } from "@/api";
import vFilter from "@/assets/js/filter";
import Vue from "vue";
for (let key in vFilter) {
  Vue.filter(key, vFilter[key]);
}
let test = [];
for(let i = 0;i<20;i++){
    test.push({
        memberId:i
    })
}

export default {
  data() {
    return {
      keyName: "",
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      total: 0,
      fullscreenLoading: false
    };
  },
  created() {
    this.search();
  },
  methods: {
    tableRowClassName({ row, column, rowIndex, columnIndex }) {
      //把每一行的索引放进row
      if (rowIndex%2 == 1) {
        return 'highLight';
      }
      return '';
    },
    specialCharacter() {
      this.keyName = this.keyName.replace(
        /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/im,
        ""
      );
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    async search(val) {
      this.fullscreenLoading = true;
      if (val == 1) {
        this.currentPage = 1;
      }
      let res = await searchMem({
        keyword: this.keyName,
        pageSize: this.pageSize,
        pageNumber: this.currentPage
      });
      this.fullscreenLoading = false;
    //   this.total = res.data.total;
    //   this.tableData = res.data.rows;
        this.total = 20;
        this.tableData = test;
    },
    addMemes() {
      // 添加兼职调理师
      this.$router.push("/basicDataCenter/addPartmem");
    },
    viewMem(id){
        // 查看
        this.$router.push("/basicDataCenter/viewPartmem/" + id);
    },
    editMem(id) {
      // 修改
      this.$router.push("/basicDataCenter/editPartmem/" + id);
    },
  }
};
</script>
<style lang="less" scoped>
.main {
  padding: 25px 0;
  .infosearch {
    .el-input__inner {
      border-radius: 20px;
    }
    .searchBtn {
      width: 47px;
      height: 38px;
      background: #f83b56 url(../../assets/images/store/btn_datalist_search.png)
        no-repeat center;
    }
    .addMems {
      color: #fff;
      font-weight: bold;
      text-indent: 20px;
      background: #3b404f url(../../assets/images/store/btn_datalist_add.png)
        no-repeat 15px center;
    }
  }
  .myMemTable {
    margin-top: 25px;
    border: 1px solid #D5D9E3;
    .el-button--mini {
      padding: 8px;
      font-weight: bold;
    }
    .el-button + .el-button {
      margin-left: 0;
    }
  }
  .emptys {
    height: 600px;
    background: url(../../assets/images/store/img_vip_none.png) no-repeat center;
    text-align: center;
    font-size: 15px;
    color: #666;
    padding-top: 450px;
  }
}
</style>
<style lang="less">
.myMemTable {
  .operation {
    .cell {
      padding: 0;
    }
  }
  .el-table__header{
    background:rgb(239, 241, 245);
  }
  .highLight {
    background: #EFF1F5;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/basicDataCenter/partTechnician.vue